import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Path } from "react-router";

import { EntityLabel, getEntityLabel } from "shared/locale/entityLabel";
import { formatNumber } from "shared/locale/format";
import { TestProps } from "shared/types";

import Link from "features/ui/Link";
import Skeleton from "features/ui/Skeleton";

interface Props extends TestProps {
  isLoading: boolean;
  error: boolean;
  count?: number;
  entityLabel: EntityLabel;
  extraClasses?: string;
  link?: string | Partial<Path>;
}

const TableCount = ({
  isLoading,
  count,
  error,
  entityLabel,
  extraClasses,
  link,
  testId,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        "inline-block text-gray-400 text-xs text-nowrap",
        extraClasses
      )}
      data-testid={testId}
    >
      {isLoading && <Skeleton width="200px" />}
      {!isLoading && error && (
        <div>
          {t("common:table_count_error", {
            entities: getEntityLabel(entityLabel, 0, t),
          })}
        </div>
      )}
      {!isLoading && !error && count !== undefined && (
        <CountDisplayWrapper link={link}>
          <span data-testid="table-count">{formatNumber(count, 0)}</span>{" "}
          {getEntityLabel(entityLabel, count, t)}
        </CountDisplayWrapper>
      )}
    </div>
  );
};

interface CountDisplayWrapperProps {
  link?: string | Partial<Path>;
  children: React.ReactNode;
}

const CountDisplayWrapper = ({ link, children }: CountDisplayWrapperProps) => {
  if (link) {
    return <Link to={link}>{children}</Link>;
  }

  return <div>{children}</div>;
};

export default TableCount;
